import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  getPoolMasterClass,
  isSupportTechnique,
} from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { P0003600EnSavoirPlusComponent } from '../../../../P0003600/Filtration/enSavoirPlus/p0003600-en-savoir-plus/p0003600-en-savoir-plus.component';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import { P0003600 } from '../../../../P0003600';
import { P0003601 } from '../../../../P0003601';
import { P0004700 } from '../../../../P0004700';
import { P00046 } from '../../../../P00046';
import { P0003605ESPInstallationClComponent } from '../../EnSavoirPlus/p0003605-espinstallation-cl/p0003605-espinstallation-cl.component';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P0003605HysteresisRegulationRx } from '../../../Enum/P0003605HysteresisRegulationRx';
import { P0003605ConsigneRegulationRxEnum } from '../../../Enum/P0003605ConsigneRegulationRx';
import { P0003605DureeQuotidienneInjection } from '../../../Enum/P0003605DureeQuotidienneInjection';
import { P0003605DureeLimiteSurdosage } from '../../../Enum/P0003605DureeLimiteSurdosage';

@Component({
  selector: 'app-p0003605-injection-chlore-parameters',
  templateUrl: './p0003605-injection-chlore-parameters.component.html',
  styleUrls: ['./p0003605-injection-chlore-parameters.component.scss'],
  imports: [
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
  ],
})
export class P0003605InjectionChloreParametersComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private slideModalService: SlideModalController =
    inject(SlideModalController);

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {
    this.P0003605ESPInstallationCl = this.P0003605ESPInstallationCl.bind(this);
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  hasProduitP0003600() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0003600()) ?? 0;
  }

  hasProduitP0003601() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0003601()) ?? 0;
  }

  hasProduitP0004700() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0004700()) ?? 0;
  }

  hasProduitP00046() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00046()) ?? 0;
  }

  async P0003605ESPInstallationCl() {
    const modal = await this.slideModalService.create({
      component: P0003605ESPInstallationClComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003605HysteresisRegulationRx =
    P0003605HysteresisRegulationRx;
  protected readonly P0003605ConsigneRegulationRxEnum =
    P0003605ConsigneRegulationRxEnum;
  protected readonly P0003605DureeQuotidienneInjection =
    P0003605DureeQuotidienneInjection;
  protected readonly P0003605DureeLimiteSurdosage =
    P0003605DureeLimiteSurdosage;
  protected readonly isSupportTechnique = isSupportTechnique;
}
